// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateAddressField = (errors: any, type: any, property: string): boolean => {
  return Boolean(errors[type]?.[property]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateField = (errors: any, property: string): boolean => {
  return Boolean(errors[property]); //TODO: test this
};
